import "../App.css";
import BlundellsScroll from "./BlundellsScroll";
import Video from "../components/Video";
import AboutSection from "./AboutSection";
import StrengthSection from "./StrengthSection";
import SchoolFeaturesSection from "./SchoolFeatures";
import PopupModel from "./PopupModal";
import VisionNews from "./VisionNews";
import CertificateSlider from "./CertificateSlider";

function Home(){

  return (
    <>
    <PopupModel/>
    <Video />
      <AboutSection />
      <StrengthSection />
      <VisionNews/>
    <BlundellsScroll></BlundellsScroll>
     <SchoolFeaturesSection/>
     <CertificateSlider/>
    </>
  );
}
export default Home;